<template>
    <div class="privilege"
        v-if="isHaveCampaignList">
        <div class="text-header">สิทธิพิเศษอื่นๆ</div>
        <div class="list-product">
            <PrivilegeList
                :list="campaigns"
                :isLoaded="isHaveCampaignList" />
        </div>
        <div class="btn-all">
            <button class="btn-tranparent-wrapper btn-big" @click="clickToPage('privilege')">{{lbl.home.text_all}}</button>
        </div>
    </div>
</template>
<script>
//component
import PrivilegeList from "./PrivilegeList.vue";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'PrivilegeSection',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    components: {
        PrivilegeList
    },
    props: {
        listPrivilegeConfig: Object,
        modalController: Object
    },
    data: function () {
        return {
            campaigns: [],
            listName: 'privilege',
            isHaveCampaignList: false,

            trackingService: new TrackingService(this),
            trackingEventCategory: 'privilagelist_page'
        }
    },
    created: function() {
        this.getListCampaign();
        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.modalController.alertModal);

        this.trackingService.event(this.trackingEventCategory, 'view_campaign_list', null, null)
    },
    methods: {
        //event
        clickToPage: function(page){
            this.trackingService.event(this.trackingEventCategory, 'click_to_view_all_campaign_list', null, null)

            if (this.$route.path !== page) this.$router.push("/" +page);
        },
        apiLoaded: function (data) {
            this.$emit('apiLoaded', data);
        },
        getListCampaign: function(){
            var token = this.getToken();
            BzbsCampaign.apiGetCampaign(token, this.listPrivilegeConfig, null)
                .then(res => {
                    if (this.campaigns.length == 0) {
                        this.campaigns = res;
                    }else {
                        for (var i of res) {
                            this.campaigns.push(i);
                        }
                    }

                    this.isHaveCampaignList = this.campaigns.length > 0
                        ? true
                        : false;

                    this.$emit('apiLoaded', {type: this.listName});
                }).catch(err => {
                    this.isHaveCampaignList = false;
                    this.errorResponse(err, this.errorHandler);
                    this.$emit('apiLoaded', {type: this.listName});
                });
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "@/module/Home/page/Home.scss";
</style>

